import { useCallback } from 'react'

import { setPlaybackPosition } from '../utils/persistPlaybackPosition'
import { usePlaybackState } from '../../firebase/hooks/useVideoPlayback'

import usePlaybackIntent from './usePlaybackIntent'

const usePlaybackNewPosition = () => {
  const playbackState = usePlaybackState()
  const { setPlaybackPlayIntent, setPlaybackScrubIntent } = usePlaybackIntent()

  const setNewPosition = useCallback(
    (newPosition) => {
      if (playbackState?.state === 'ended') {
        const {
          statePayload: { photoId, url },
        } = playbackState
        const video = {
          photo_id: photoId,
          video_hd_download: url,
        }
        // first we write the new position in locale storage, which will be used by setPlaybackPlayIntent
        setPlaybackPosition(photoId, newPosition)

        // reset playing state in Firebase and headless
        setPlaybackPlayIntent(video)
      } else {
        // send scrub intent with new position if the video is not in ended state
        setPlaybackScrubIntent(newPosition)
      }
    },
    [playbackState, setPlaybackScrubIntent, setPlaybackPlayIntent]
  )

  return { setNewPosition }
}
export default usePlaybackNewPosition
